import {ReactChild, ReactChildren, useState} from 'react'
import {Button, Modal} from 'react-bootstrap'
import {KTSVG} from '_metronic/helpers'

type Props = {
  size?: 'sm' | 'lg' | 'xl'
  title: string
  txtOk?: string
  txtCancel?: string
  stateShow: boolean
  onConfirmClick?: (e: any) => void
  onHide: () => void
  children?: React.ReactNode
  showOK?: boolean
  showCancel?: boolean
  showHeader?: boolean
  showFooter?: boolean,
  
} & typeof defaultProps

const defaultProps = {
  size: 'lg',
  txtOk: 'OK',
  txtCancel: 'Cancel',
  showOK: true,
  showCancel: true,
  showHeader: true,
  showFooter: true,
}

export const ModalBox = (props: Props) => {
  //const [show, setShow] = useState(props.stateShow)

  const handleOk = (e: any) => {
    props.onConfirmClick?.(e)
  }

  const handleCancel = (e: any) => {
    props.onHide()
  }

  return (
    <Modal
      size={props.size}
      show={props.stateShow}
      onHide={props.onHide}
      centered
      tabIndex='-2'
      style={{zIndex: 1056}}
    >
      {props.showHeader && (
        <Modal.Header closeButton>
          <Modal.Title>{props?.title}</Modal.Title>
          {/* <div onClick={props.onHide}>
            <KTSVG className='svg-icon svg-icon-2' path='/media/icons/duotune/art/art005.svg' />
          </div> */}
        </Modal.Header>
      )}

      <Modal.Body>{props.children}</Modal.Body>

      {props.showFooter && (
        <Modal.Footer>
          {props.showCancel ? (
            <Button variant='secondary' onClick={(e: any) => handleCancel(e)}>
              {props.txtCancel}
            </Button>
          ) : (
            ''
          )}
          {props.showOK ? (
            <Button variant='primary' onClick={(e: any) => handleOk(e)}>
              {props.txtOk}
            </Button>
          ) : (
            ''
          )}
        </Modal.Footer>
      )}
    </Modal>
  )
}
ModalBox.defaultProps = defaultProps
